.practiceplace {
  display: inline-flex;
}

.toggleButton {
  transform: scale(0.85);
}

.practiceplaceName {
  display: flex;
  align-items: center;
  margin: auto;
}

.practiceplaceNameStrong {
  @extend .practiceplaceName;
  font-weight: 600;
  margin: auto;
}

.icon {
  margin-right: 0.5em;
}

.endNode {
  display: flex;

  svg {
    margin: auto;
  }
}
